//libs
import React from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Container, Title, TagsContainer, Tag, ImageContainer, Label, Image } from './styles';

// const
const TAG_IMAGE_WIDTH = 20;
const TAG_IMAGE_ASPECT_RATIO = 1;

//defs

interface ITag {
  label: string;
  image_url: string;
}
interface IResponsibleTags {
  className?: string;
  widget: {
    action_url: string;
    placeholder_text: string;
    widget_id: string;
    widget_type: string;
    title: string;
    read_more: boolean;
    tags: ITag[];
  };
  responsibleTagsEnabled: boolean;
  isMobile: boolean;
}

function ResponsibleTags({
  className = '',
  widget,
  responsibleTagsEnabled,
  isMobile,
}: IResponsibleTags) {
  if (!responsibleTagsEnabled || isEmpty(widget)) {
    return null;
  }

  return (
    <Container data-test="parent--" className={className}>
      <Title data-test="widget-title-test">{widget.title}</Title>
      <TagsContainer>
        {widget.tags.map((tag: any, i: number) => {
          return (
            <Tag key={`responsible-tag-${tag.label || i}`} width={isMobile ? 25 : 20}>
              <ImageContainer>
                <Image
                  src={tag.image_url}
                  width={TAG_IMAGE_WIDTH}
                  aspectRatio={TAG_IMAGE_ASPECT_RATIO}
                  animate={false}
                  alt="responsible tag image"
                />
              </ImageContainer>
              <Label>{tag.label}</Label>
            </Tag>
          );
        })}
      </TagsContainer>
    </Container>
  );
}

export default ResponsibleTags;
